"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var l = require("lenovo");
var lenovo_1 = require("lenovo");
var JsBarcode = require("jsbarcode");
var Buffer = require('buffer').Buffer;
var LZ4 = window.require('lz4');
var _currentCategory;
var CustomerServiceableType = /** @class */ (function () {
    function CustomerServiceableType() {
    }
    CustomerServiceableType.Consumable = l.Translator.translate("consumable");
    CustomerServiceableType.Mandatory = l.Translator.translate("mandatory");
    CustomerServiceableType.Optional = l.Translator.translate("optional");
    CustomerServiceableType.FRUOnly = l.Translator.translate("fru only");
    CustomerServiceableType.Defaulttype = "-";
    return CustomerServiceableType;
}());
var EventCategory;
(function (EventCategory) {
    EventCategory[EventCategory["ProductDescription"] = 0] = "ProductDescription";
    EventCategory[EventCategory["TopFeatures"] = 1] = "TopFeatures";
    EventCategory[EventCategory["TechSpecs"] = 2] = "TechSpecs";
    EventCategory[EventCategory["SystemType"] = 3] = "SystemType";
    // Photo
    //from psp
    EventCategory[EventCategory["BarCode"] = 4] = "BarCode";
    EventCategory[EventCategory["Photo"] = 5] = "Photo";
    EventCategory[EventCategory["Feedback"] = 6] = "Feedback";
    EventCategory[EventCategory["Substitution"] = 7] = "Substitution";
    //for add to cart
    EventCategory[EventCategory["OutOfStock"] = 8] = "OutOfStock";
    //for change number text
    EventCategory[EventCategory["OutOfStockTips"] = 9] = "OutOfStockTips";
    EventCategory[EventCategory["Serviceable"] = 10] = "Serviceable";
    EventCategory[EventCategory["Cart"] = 11] = "Cart";
    EventCategory[EventCategory["Details"] = 12] = "Details";
    EventCategory[EventCategory["Description"] = 13] = "Description";
    EventCategory[EventCategory["Features"] = 14] = "Features";
    EventCategory[EventCategory["Specs"] = 15] = "Specs";
    EventCategory[EventCategory["PartsFilters"] = 16] = "PartsFilters";
    EventCategory[EventCategory["AccessoryFilters"] = 17] = "AccessoryFilters";
    EventCategory[EventCategory["MBack"] = 18] = "MBack";
    EventCategory[EventCategory["Graphic"] = 19] = "Graphic";
    EventCategory[EventCategory["List"] = 20] = "List";
    EventCategory[EventCategory["Schematic"] = 21] = "Schematic";
    EventCategory[EventCategory["WarrantyInfo"] = 22] = "WarrantyInfo";
    EventCategory[EventCategory["PartList"] = 23] = "PartList";
})(EventCategory = exports.EventCategory || (exports.EventCategory = {}));
var ConfigurationCategory;
(function (ConfigurationCategory) {
    ConfigurationCategory[ConfigurationCategory["AsBuilt"] = 0] = "AsBuilt";
    ConfigurationCategory[ConfigurationCategory["Model"] = 1] = "Model";
    ConfigurationCategory[ConfigurationCategory["Compatible"] = 2] = "Compatible";
    ConfigurationCategory[ConfigurationCategory["Schematic"] = 3] = "Schematic";
    ConfigurationCategory[ConfigurationCategory["Substitution"] = 4] = "Substitution";
    ConfigurationCategory[ConfigurationCategory["UnKnow"] = 5] = "UnKnow";
})(ConfigurationCategory = exports.ConfigurationCategory || (exports.ConfigurationCategory = {}));
var ProductType;
(function (ProductType) {
    ProductType["Serial"] = "Product.Serial";
    ProductType["Model"] = "Product.Model";
    ProductType["MachineType"] = "Product.MachineType";
    ProductType["SubSeries"] = "Product.SubSeries";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
function GetScrollTop() {
    var scrollPos;
    if (window.pageYOffset) {
        scrollPos = window.pageYOffset;
    }
    else if (document.compatMode && document.compatMode != 'BackCompat') {
        scrollPos = document.documentElement.scrollTop;
    }
    else if (document.body) {
        scrollPos = document.body.scrollTop;
    }
    return scrollPos;
}
exports.GetScrollTop = GetScrollTop;
var Tracking = /** @class */ (function () {
    function Tracking() {
    }
    Tracking.Set = function (Interac, IsAccessory) {
        if (IsAccessory === void 0) { IsAccessory = false; }
        var currentCategoryVal = null;
        switch (this._currentCategory) {
            case ConfigurationCategory.AsBuilt:
                currentCategoryVal = "AsBuilt";
                break;
            case ConfigurationCategory.Model:
                currentCategoryVal = "Model";
                break;
            case ConfigurationCategory.Compatible:
                currentCategoryVal = "Compatible";
                break;
        }
        if (window["lmd"] && window["_satellite"]) {
            window["lmd"].checkboxfilters = IsAccessory ? this.AccessoryFilter : (currentCategoryVal + " - " + this.PartsFilter);
            window["lmd"].custominteraction = Interac;
            window["_satellite"].track('checkbox-selected');
        }
    };
    Tracking.Log = function (type, action, name) {
        var ds_productinfo = window["ds_productinfo"] || {};
        l.DTM.push({
            type: type,
            name: name,
            action: action,
            eSupportDeviceInfo: {
                serialNumber: ds_productinfo.Serial,
                machineTypeModel: ds_productinfo.MachineType
            }
        });
    };
    Tracking.PusherrorinfTrack = function (type, message) {
        l.DTM.Lmd.pusherrorinfTrack(type, message);
    };
    Tracking.TabClickTrack = function (tabname) {
        //UPS-662  Tab click tracking
        if (window["lmd"] && window["_satellite"]) {
            window["lmd"].subsubsection = tabname;
            window["_satellite"].track("virtual-tab-click");
        }
    };
    Tracking.OutOfStockTrack = function (paramter) {
        if (window["lmd"] && window["_satellite"]) {
            for (var key in paramter) {
                window["lmd"][key] = paramter[key];
            }
            window["_satellite"].track("out-of-stock-click");
        }
    };
    Tracking.outOfSubstituteStockTrack = function (paramter) {
        if (window["lmd"] && window["_satellite"]) {
            for (var key in paramter) {
                window["lmd"][key] = paramter[key];
            }
            window["_satellite"].track("out-of-substitute-stock-click");
        }
    };
    Tracking.SubstituteClickTrack = function (paramter) {
        if (window["lmd"] && window["_satellite"]) {
            for (var key in paramter) {
                window["lmd"][key] = paramter[key];
            }
            window["_satellite"].track("substitute-click");
        }
    };
    Tracking.SearchTermTrack = function (pageType, partaccNumber, searchProductType, success) {
        if (pageType === void 0) { pageType = 1; }
        if (success === void 0) { success = true; }
        // 1:Parts Lookup, 2:Accessories Lookup, 3: PSP
        window["lmd"].intSearchLoc = pageType == 1 ? "Parts LookUp" : pageType == 2 ? "Accessories Lookup" : "Parts lookup PSP";
        window["lmd"].SearchType = "Product Search";
        window["lmd"].SearchProductType = searchProductType;
        window["lmd"].partaccNumber = (pageType == 1 || pageType == 3 ? "prt-" : "acc-") + partaccNumber.toUpperCase();
        window["lmd"].errorDetail = success ? "" : "No results found";
        window["lmd"].errorType = success ? "" : (pageType == 1 ? "Parts Lookup" : pageType == 2 ? "Accessories Lookup" : "Parts lookup PSP");
        if (success)
            window["_satellite"].track("Parts_And_Accessories_Lookup");
        else
            window["_satellite"].track("User-Interaction-error");
    };
    Tracking.ImageClickTrack = function (prtOrAcc, partaccNumber) {
        if (prtOrAcc === void 0) { prtOrAcc = "prt"; }
        window["lmd"].partaccNumber = (prtOrAcc == "prt" ? "prt-" : "acc-") + partaccNumber.toUpperCase();
        window["_satellite"].track("Parts_And_Accessories_Image_Lookup");
    };
    Tracking.PartsFilter = "";
    Tracking.AccessoryFilter = "";
    return Tracking;
}());
exports.Tracking = Tracking;
function CurrentCategory() {
    return this._currentCategory;
}
exports.CurrentCategory = CurrentCategory;
function RecordCurrentCategory(category) {
    this._currentCategory = category;
    Tracking._currentCategory = category;
}
exports.RecordCurrentCategory = RecordCurrentCategory;
function IsDcgSite() {
    return l.Common.getCurrentRealm() == lenovo_1.RealmType.Dcg;
}
exports.IsDcgSite = IsDcgSite;
function IsPcgSite() {
    return l.Common.getCurrentRealm() == lenovo_1.RealmType.Pcg;
}
exports.IsPcgSite = IsPcgSite;
function IsGlobalSite() {
    return l.Common.getCurrentRealm() == lenovo_1.RealmType.All;
}
exports.IsGlobalSite = IsGlobalSite;
function CurrentProductType() {
    return window["ds_pspparts"].QueryType;
}
exports.CurrentProductType = CurrentProductType;
function IsCCorSPuser() {
    return (window["ds_pspparts"] ? window["ds_pspparts"].isCCorSPuser : '') || (window["ds_partsconfig"] ? window["ds_partsconfig"].isCCorSPuser : '');
}
exports.IsCCorSPuser = IsCCorSPuser;
function IsCanBuyAccessory() {
    return typeof window["WPSShop"] === "object" && window["ShopConfig"] && window["ShopConfig"]["Accessory"] && window["ShopConfig"]["Accessory"]["IsSupported"];
}
exports.IsCanBuyAccessory = IsCanBuyAccessory;
function IsCanBuyParts() {
    return typeof window["WPSShop"] === "object" && window["ShopConfig"] && window["ShopConfig"]["Parts"] && window["ShopConfig"]["Parts"]["IsSupported"];
}
exports.IsCanBuyParts = IsCanBuyParts;
function IsCanBuyWarranty() {
    return typeof window["WPSShop"] === "object" && window["ShopConfig"] && window["ShopConfig"]["Warranty"] && window["ShopConfig"]["Warranty"]["IsSupported"];
}
exports.IsCanBuyWarranty = IsCanBuyWarranty;
function IsUsingUnifiedCart() {
    return window["ShopConfig"] && window["ShopConfig"]["UsingUnifiedCart"] == true;
}
exports.IsUsingUnifiedCart = IsUsingUnifiedCart;
function GetAvailableQuantity() {
    return window["ds_partsconfig"].AvailableQuantity;
}
exports.GetAvailableQuantity = GetAvailableQuantity;
function IsAllowedToOversell() {
    return window["ds_partsconfig"].IsAllowedToOversell;
}
exports.IsAllowedToOversell = IsAllowedToOversell;
function IsMobileOrTable() {
    return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
}
exports.IsMobileOrTable = IsMobileOrTable;
function CompaireObject(arg1, arg2) {
    var aProps = Object.getOwnPropertyNames(arg1);
    var bProps = Object.getOwnPropertyNames(arg2);
    if (aProps.length != bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (arg1[propName] !== arg2[propName]) {
            return false;
        }
    }
    return true;
}
exports.CompaireObject = CompaireObject;
function CompaireArray(array1, array2) {
    if (!array1 || !array2)
        return false;
    if (array1.length != array2.length)
        return false;
    for (var i = 0, l = array1.length; i < l; i++) {
        if (array1[i] instanceof Array && array2[i] instanceof Array) {
            if (!array1[i].equals(array2[i]))
                return false;
        }
        else if (array1[i] != array2[i]) {
            return false;
        }
    }
    return true;
}
exports.CompaireArray = CompaireArray;
function GetProductID(IsAccessory) {
    if (IsAccessory === void 0) { IsAccessory = false; }
    var ds_productinfo = window["ds_productinfo"] || {};
    var serial = ds_productinfo.Serial;
    if (serial && ds_productinfo.Serial.split(".").length > 1) {
        serial = ds_productinfo.Serial.split(".")[0];
    }
    if (IsAccessory) {
        var productId = serial || ds_productinfo.Model || ds_productinfo.MachineType || window["ds_pspparts"].MT || ds_productinfo.ProductName;
        return productId;
    }
    else {
        switch (this._currentCategory) {
            case ConfigurationCategory.AsBuilt:
                return serial;
            case ConfigurationCategory.Model:
                return ds_productinfo.Model;
            case ConfigurationCategory.Compatible:
                //The value of 'ds_productinfo.MachineType' may be empty.
                return ds_productinfo.MachineType || window["ds_pspparts"].MT;
            default:
                return ds_productinfo.ProductName;
        }
    }
}
exports.GetProductID = GetProductID;
function GetCrutierName(crutier, changeLine) {
    if (changeLine === void 0) { changeLine = true; }
    switch (crutier) {
        case 0: return CustomerServiceableType.Consumable + (IsDcgSite() ? "" + (changeLine ? "<br />(C)" : " (C)") : "");
        case 1: return CustomerServiceableType.Mandatory + (IsDcgSite() ? "" + (changeLine ? "<br />(T1 CRU)" : " (T1 CRU)") : "");
        case 2: return CustomerServiceableType.Optional + (IsDcgSite() ? "" + (changeLine ? "<br />(T2 CRU)" : " (T2 CRU)") : "");
        case 9: return CustomerServiceableType.FRUOnly;
        default: return CustomerServiceableType.Defaulttype;
    }
}
exports.GetCrutierName = GetCrutierName;
function GetCrutierDescription(crutier) {
    switch (crutier) {
        case 0: return l.Translator.translate("part not covered desc");
        case 1: return l.Translator.translate("part must be installed by customer");
        case 2: return l.Translator.translate("part may be installed by customer");
        case 9: return l.Translator.translate("part must be installed by lenovo");
        default: return CustomerServiceableType.Defaulttype;
    }
}
exports.GetCrutierDescription = GetCrutierDescription;
function GetPartsListClass() {
    var column = 4;
    //Price
    if (IsCanBuyParts())
        column = column + 3;
    if (!IsDcgSite()) {
        //Photo
        column++;
        //FeedBack
        if (IsCCorSPuser())
            column++;
    }
    //MFG
    if (this._currentCategory == ConfigurationCategory.AsBuilt)
        column++;
    return "datalist_box column-" + column;
}
exports.GetPartsListClass = GetPartsListClass;
function StrFilter(inputStr) {
    if (!inputStr)
        return;
    inputStr = inputStr.replace(/<br>/g, "");
    inputStr = inputStr.replace(/&lt;br&gt;/g, "");
    inputStr = inputStr.replace(/&amp;lt;br&amp;gt;/g, "");
    inputStr = inputStr.replace(/&lt;/g, "<");
    inputStr = inputStr.replace(/&gt;/g, ">");
    inputStr = inputStr.replace(/&amp;/g, "&");
    inputStr = inputStr.replace(/&nbsp;/g, " ");
    inputStr = inputStr.replace(/&quot;/g, "");
    inputStr = inputStr.replace(/&apos;/g, "");
    inputStr = inputStr.replace(/\ufffd./g, "");
    inputStr = inputStr.replace(/\?/g, " ");
    inputStr = inputStr.replace(/\"/g, "");
    return inputStr;
}
exports.StrFilter = StrFilter;
function HTMLDecode(text) {
    var temp = document.createElement("div");
    temp.innerHTML = text;
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output;
}
exports.HTMLDecode = HTMLDecode;
function TextToBase64Barcode(text) {
    var canvas = document.createElement("canvas");
    JsBarcode(canvas, text, { format: "CODE39" });
    return canvas.toDataURL("image/png");
}
exports.TextToBase64Barcode = TextToBase64Barcode;
var InterfaceUtility = /** @class */ (function () {
    function InterfaceUtility() {
    }
    InterfaceUtility.getSubstitution = function (formdata, success, error, beforeSend) {
        $.ajax({
            type: "post",
            url: l.UrlUtility.getFullServicesPath("/partslookup/getsubstitution"),
            data: formdata,
            beforeSend: beforeSend,
            success: success,
            error: error
        });
    };
    InterfaceUtility.submitUploadImageInfo = function (formdata, success, error, beforeSend) {
        $.ajax({
            type: "post",
            url: l.UrlUtility.getFullServicesPath("/parts/submituploadimageinfo"),
            data: formdata,
            beforeSend: beforeSend,
            success: success,
            error: error
        });
    };
    return InterfaceUtility;
}());
exports.InterfaceUtility = InterfaceUtility;
function Encode(data) {
    var rawString = JSON.stringify(data);
    var rawBuffer = new Buffer(rawString, "utf8");
    var originLength = rawBuffer.length;
    var output = new Buffer(LZ4.encodeBound(originLength));
    var compressedSize = LZ4.encodeBlock(rawBuffer, output);
    output = output.slice(0, compressedSize);
    return { content: output.toString('base64'), originLength: originLength };
}
exports.Encode = Encode;
// Get product's serial number.
function GetProductSerial() {
    var ds_productinfo = window['ds_productinfo'] || {};
    var serial = ds_productinfo.Serial;
    if (serial && ds_productinfo.Serial.split('.').length > 1) {
        serial = ds_productinfo.Serial.split('.')[0];
    }
    return serial;
}
exports.GetProductSerial = GetProductSerial;
// Check if PRC site.
function CheckIsPRC() {
    //@ts-ignore-next-line
    var _a = window.config, config = _a === void 0 ? {} : _a;
    var _b = config.user, user = _b === void 0 ? {} : _b;
    var _c = user.Country, Country = _c === void 0 ? '' : _c;
    var PRCCountry = 'cn';
    return Country === PRCCountry;
}
exports.CheckIsPRC = CheckIsPRC;
